//
//
//
//
//
//
//
//
//
//
//
//
//

import TEnrollDetail from '@/views/prepareEnroll/TEnrollDetail'
import baseInfoWrite from './baseInfo/baseInfoWrite'// 填写基本信息
import studyExperienceWrite from './studyExperience/studyExperienceWrite'
import familyInfoWrite from './familyInfo/familyInfoWrite'
import userLogoUpload from './userLogo/userLogoUpload'// 上传图片
import attachmentInfo from './attachment/attachmentInfo'// 附件信息
import TDoEnroll from './TDoEnroll'

const comMap = {
  'TChooseEnrollType': { title: '考试报名' },
  'TDoEnroll': { title: '考试报名' },
  'TEnrollDetail': { title: '报名详情' },
}

export default {
  name: 'StartEnroll',

  components: {
    TDoEnroll,
    baseInfoWrite,
    userLogoUpload,
    studyExperienceWrite,
    attachmentInfo,
    familyInfoWrite,
    TEnrollDetail,
  },

  data () {
    return {
      currentComponent: {
        name: TDoEnroll,
        title: '考试报名',
        options: {},
      },
    }
  },

  methods: {
    changeComponent (name, configOptions = {}) {
      this.currentComponent = {
        name,
        ...comMap[name] || {},
        ...configOptions,
      }
    },
  },
}
